module.exports = __webpack_public_path__ + "img/question-mark.860d5cb3.jpg";